import * as FormHelpers from './forms/helpers';
import * as Widget from './driftrock_widget';
import * as WidgetNew from './driftrock_widget_new';
import { track_event } from './driftrock_tracking';
import * as Attribution from './driftrock_attribution';
import { getCMP }from './cmp'

function base_url() {
  switch (Driftrock.settings.env) {
    case "test":
      return "http://inbound-leads:4021";
    case "e2e":
      return "http://inbound-leads-test-server:4021";
    case "development":
      return "http://public-gateway:4010";
    case "staging":
      return "https://external-apis.stagingrock.com";
    default:
      return "https://external-apis.driftrock.com";
  }
}

function init_config() {
  return fetch(
    `${Driftrock.settings.base_url}/v2/website_config`,
    {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${Driftrock.settings.api_key}`,
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify({})
    }
  )
    .then(FormHelpers.handleApiError)
    .then(response => response.json())
    .then(json_response => {
      window.Driftrock.config = json_response;
    })
}

function setup_common() {
  const cmp = getCMP()
  if (cmp) {
    cmp.onConsentChanged?.(() => {
      if (cmp.hasGrantedPermission()) {
        Attribution.set_first_touch();
        Attribution.set_ad_click_ids();
      }
    })

    if (!cmp.hasGrantedPermission()) {
      return
    }
  }

  Attribution.set_first_touch();
  Attribution.set_ad_click_ids();
}

function setup_widgets() {
  if (Driftrock.config.widgets_enabled) {
    const query_params = new URLSearchParams(document.location.search)

    Driftrock.widget_settings = Driftrock.settings.widget_settings || {}
    Driftrock.widget_settings.entity_version = query_params.get("entity_version") || "old";
    Driftrock.widget_settings.display_tech = query_params.get("display_tech") || "js";

    switch (query_params.get("version")) {
    case 'new':
      document.addEventListener("DOMContentLoaded", WidgetNew.init());
      break;

    default:
      document.addEventListener("DOMContentLoaded", Widget.init());
      break;
    }
  }
}

function setup_tracking() {
  if (Driftrock.config.tracking_enabled) {
    Driftrock.tracking_settings = Driftrock.settings.tracking_settings || {}
    Driftrock.track_event = track_event
  }
}

function setup_auto_capture() {
  if (Driftrock.config.auto_capture_enabled) {
    Driftrock.auto_capture_settings = Driftrock.settings.auto_capture_settings || {}
  }
}

window.Driftrock = {
  init: function (settings) {
    Driftrock.settings = settings;
    Driftrock.settings.base_url = base_url();

    return init_config()
    .then(setup_common)
    .then(setup_widgets)
    .then(setup_tracking)
    .then(setup_auto_capture)
  }
}
